// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavigationMenu_menu__FxcPv","component":"NavigationMenu_component__l7tMz"};